module.exports = __webpack_public_path__ + "assets/img/logo-norschoten.513bfc4a.png";